import { useEffect, useState } from "react";
import { Wallet, TrendingUp, CheckCircle2, Clock } from "lucide-react";
import api from "@/lib/api";
import { formatFCFA, formatDate } from "@/lib/format";
import { Loader } from "@/components/common";
import { LedgerTable } from "@/components/LedgerModal";

export default function ProEarnings() {
  const [data, setData] = useState(null);
  const [ledger, setLedger] = useState(null);
  useEffect(() => {
    api.get("/pro/earnings").then((r) => setData(r.data));
    api.get("/pro/ledger").then((r) => setLedger(r.data));
  }, []);
  if (!data) return <Loader label="Chargement des gains..." />;

  return (
    <div>
      <h1 className="font-display text-3xl font-black uppercase mb-5">Mes gains</h1>
      <div className="grid grid-cols-2 gap-3 mb-5">
        <Stat icon={TrendingUp} label="Total gagné" value={formatFCFA(data.total_earned)} accent />
        <Stat icon={CheckCircle2} label="Déjà payé" value={formatFCFA(data.total_paid)} />
        <Stat icon={Clock} label="Reste à percevoir" value={formatFCFA(data.remaining)} highlight />
        <Stat icon={Wallet} label="Interventions" value={data.missions_done} />
      </div>

      {data.remaining > 0 && (
        <div className="bg-[#E08B00]/10 border border-[#E08B00]/40 rounded-xl p-4 mb-5 text-center">
          <p className="text-[#E08B00] font-bold">💰 Paiement disponible au bureau</p>
          <p className="text-slate-400 text-sm mt-1">Montant en attente : {formatFCFA(data.remaining)}</p>
        </div>
      )}

      {ledger && (
        <div className="mb-6">
          <h2 className="font-display text-lg font-bold mb-3">Grand livre de mes gains</h2>
          <div className="bg-[#111827] border border-slate-700 rounded-xl p-4" data-testid="pro-ledger"><LedgerTable data={ledger} dark /></div>
        </div>
      )}

      <h2 className="font-display text-lg font-bold mb-3">Historique des paiements</h2>
      {data.payments.length === 0 ? <p className="text-slate-400 text-sm">Aucun paiement enregistré.</p> : (
        <div className="space-y-2">
          {data.payments.map((p) => (
            <div key={p.id} className="bg-[#1F2937] border border-slate-700 rounded-xl p-3 flex justify-between items-center" data-testid={`payment-${p.id}`}>
              <div>
                <p className="font-num font-bold text-[#E08B00]">{formatFCFA(p.amount)}</p>
                <p className="text-xs text-slate-400">{formatDate(p.date)} · {p.method} {p.reference && `· ${p.reference}`}</p>
              </div>
              <span className="text-xs text-slate-500">par {p.paid_by}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Stat({ icon: Icon, label, value, accent, highlight }) {
  return (
    <div className={`rounded-xl p-4 border ${highlight ? "bg-[#E08B00]/10 border-[#E08B00]/40" : accent ? "bg-[#1F2937] border-slate-700" : "bg-[#1F2937] border-slate-700"}`}>
      <Icon className={`w-5 h-5 mb-2 ${highlight ? "text-[#E08B00]" : "text-slate-400"}`} />
      <p className="font-num font-black text-xl text-white">{value}</p>
      <p className="text-xs text-slate-400">{label}</p>
    </div>
  );
}
